/* eslint-disable react/no-array-index-key */
import Status from './Status';

function StatusList(props) {
  const { status } = props;
  return (
    <div className="d-flex">
      {status.map(({ statusProgress, statusText }, index) => (
        <Status
          progress={statusProgress}
          text={statusText}
          key={`status-${index}`}
        />
      ))}
    </div>
  );
}

export default StatusList;
